import { Loader2 } from "lucide-react";
import { useNavigate } from "@tanstack/react-router";
import { useEffect, type ReactNode } from "react";

import { useAuth } from "@/contexts/AuthContext";

/**
 * Client-side auth gate. Redirects unauthenticated users to /login while
 * Firebase resolves auth state. Shows a spinner during the loading window.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { authLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      void navigate({ to: "/login", replace: true });
    }
  }, [authLoading, isAuthenticated, navigate]);

  if (authLoading || !isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="size-6 animate-spin text-primary" aria-label="Loading" />
      </div>
    );
  }

  return <>{children}</>;
}
